export default "//yastatic.net/s3/distribution/pythia/frontend/_/e674444c71c36583838aba0fa5f8fecd.png";